let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7I5Ph")).then(() => parcelRequire('fPTZj'));